import { render, staticRenderFns } from "./DashboardView.vue?vue&type=template&id=55e2a82c&scoped=true"
import script from "./DashboardView.vue?vue&type=script&lang=js"
export * from "./DashboardView.vue?vue&type=script&lang=js"
import style0 from "./DashboardView.vue?vue&type=style&index=0&id=55e2a82c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e2a82c",
  null
  
)

export default component.exports